(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Load jQuery and Slick from CDN
    function loadScript(url, callback) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      if (script.readyState) {
        // For IE
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // For others
        script.onload = function () {
          callback();
        };
      }
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    const initSlick = function (section) {
      const slider = section.querySelector('.testimonial-slider');
      if (!slider || slider.classList.contains('slick-initialized')) {
        return;
      }

      const autoplay = slider.dataset.autoplay === 'true';
      const desktopSlides = parseInt(slider.dataset.desktopSlides, 10);

      $(slider).slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: desktopSlides,
        slidesToScroll: 1,
        autoplay: autoplay,
        autoplaySpeed: 5000,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    };

    const destroySlick = function (section) {
      const slider = section.querySelector('.testimonial-slider');
      if (slider && slider.classList.contains('slick-initialized')) {
        $(slider).slick('unslick');
      }
    };

    const loadAndInit = function () {
      loadScript('https://code.jquery.com/jquery-3.6.0.min.js', function () {
        loadScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', function () {
          document.querySelectorAll('.testimonial-section-wrapper').forEach(function (section) {
            initSlick(section);
          });
        });
      });
    };

    document.addEventListener('DOMContentLoaded', loadAndInit);

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('.testimonial-section-wrapper')) {
        initSlick(event.target);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.querySelector('.testimonial-section-wrapper')) {
        destroySlick(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        document.body.classList.add('scroll-active');
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        document.body.classList.add('scroll-active');
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        document.body.classList.remove('scroll-active');
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {

  function load(u, c) {
    var s = document.createElement('script');
    s.onload = c;
    s.src = u;
    document.head.appendChild(s);
  }

  var mq = window.matchMedia('(max-width: 749px)');
  var observers = new WeakMap();

  function initSlider(el) {
    if (!mq.matches) return;
    if (el.classList.contains('slick-initialized')) return;
    if (el.offsetWidth === 0) return;

    $(el).slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: el.dataset.autoplay === "true",
      arrows: true,
      adaptiveHeight: true
    });
  }

  function destroySlider(el) {
    if (el.classList.contains('slick-initialized')) {
      $(el).slick('unslick');
    }
  }

  function watch(el) {
    if (observers.has(el)) return;

    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var width = entry.contentRect.width;

        if (!mq.matches) {
          destroySlider(el);
          return;
        }

        if (width === 0) {
          destroySlider(el);
          return;
        }

        if (!el.classList.contains('slick-initialized')) {
          initSlider(el);
        } else {
          $(el).slick('setPosition');
        }
      });
    });

    ro.observe(el);
    observers.set(el, ro);
  }

  function apply() {
    document.querySelectorAll('.product-images').forEach(function (el) {
      watch(el);

      if (mq.matches) {
        initSlider(el);
      } else {
        destroySlider(el);
      }
    });
  }

  function boot() {
    if (window.jQuery && $.fn.slick) {
      apply();
      return;
    }

    load('https://code.jquery.com/jquery-3.6.0.min.js', function () {
      load(
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js',
        apply
      );
    });
  }

  mq.addEventListener
    ? mq.addEventListener('change', apply)
    : mq.addListener(apply);

  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:section:select', apply);

})();

  } catch(e) { console.error(e); }
})();
})();
